module.exports = __webpack_public_path__ + "img/qr-code.dc379b20.svg";